import { gql, useMutation } from "@apollo/client";

import { COST_CENTERS_QUERY } from "./fetch";
export const useDeleteCostCenters = () => {
  const [deleteCostCenters] = useMutation(DELETE_COST_CENTERS_MUTATION, {
    refetchQueries: [COST_CENTERS_QUERY],
  });

  return async (costCenterIds: string[]) => {
    const res = await deleteCostCenters({
      variables: { costCenterIds },
    });
    return res.data.deleteInvoices;
  };
};

export const DELETE_COST_CENTERS_MUTATION = gql`
  mutation deleteManyCostCenters($costCenterIds: [String!]!) {
    deleteManyCostCenters(costCenterIds: $costCenterIds)
  }
`;
